import { useEffect, useState } from 'react'
import fileApi from '../api/services/FileApi'
import { RequestStatus } from '../api/types'

const useFetchImage = (
  imageId: string | null | undefined,
  signal: AbortSignal
) => {
  const [requestStatus, setRequestStatus] = useState<RequestStatus>(
    RequestStatus.Idle
  )

  const [image, setImage] = useState<string | ArrayBuffer | null>(null)

  useEffect(() => {
    if (!imageId) return
    const fetchData = async () => {
      setRequestStatus(RequestStatus.Pending)
      const data = await fileApi.download(imageId, signal)

      const reader = new FileReader()
      reader.readAsDataURL(new Blob([data]))
      reader.onloadend = () => {
        setImage(reader.result)
        setRequestStatus(RequestStatus.Fulfilled)
      }
      reader.onerror = () => {
        setImage(null)
        setRequestStatus(RequestStatus.Rejected)
      }
    }

    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imageId])

  return { requestStatus, image }
}
export default useFetchImage
